import actions from './actions'
import getters from './getters'
import * as types from './types'
import Vue from 'vue'

const initialState = {
  isFetchingList: false,
  isFetchingStatus: false,
  listUploadedFiles: null
}

const state = {
  isFetchingList: false,
  isFetchingStatus: false,
  listUploadedFiles: null,
  listNextCursor: null
}

const mutations = {
  [types.SET_IS_FETCHING_LIST] (state, action) {
    state.isFetchingList = action.flag
  },
  [types.SET_IS_FETCHING_STATUS] (state, action) {
    state.isFetchingStatus = action.flag
  },
  [types.SET_LIST_UPLOADED_FILES] (state, action) {
    state.listUploadedFiles = action.uploads
  },
  [types.INFINITE_SET_LIST_UPLOADED_FILES] (state, action) {
    if (state.listUploadedFiles != null) {
      state.listUploadedFiles = [...state.listUploadedFiles, ...action.uploads]
    } else {
      state.listUploadedFiles = action.uploads
    }
  },
  [types.SET_LIST_NEXT_CURSOR](state, action) {
    state.listNextCursor = action.nextCursor
  },
  [types.SET_UPLOAD_FILE_STATUS](state, action) {
    const index = state.listUploadedFiles.findIndex(({ uploadID }) => {
      return uploadID ===  action.uploadFile.uploadID
    })
    if (index >= 0) {
      Vue.set(state.listUploadedFiles, index, {...state.listUploadedFiles[index], ...action.uploadFile})
    }
  }
}

export const uploads = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
